import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={735}
    height={5}
    fill="none"
    {...props}
  >
    <path
      stroke="url(#asg)"
      strokeLinecap="round"
      strokeWidth={2}
      d="M734 1H584"
    />
    <path
      stroke="url(#bsg)"
      strokeLinecap="round"
      strokeWidth={2}
      d="m521.648 2.703-511.647.298"
    />
    <path fill="url(#c)" d="M0 5h4v4H0z" transform="rotate(-90 0 5)" />
    <defs>
      <linearGradient
        id="asg"
        x1={841}
        x2={329.353}
        y1={1.149}
        y2={1.149}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCFA2" />
        <stop offset={0.095} stopColor="#8C866B" />
        <stop offset={0.24} stopColor="#8C866A" />
        <stop offset={0.475} stopColor="#F5E6B6" />
        <stop offset={0.62} stopColor="#8C866B" />
        <stop offset={0.86} stopColor="#8C866B" />
        <stop offset={1} stopColor="#A59A87" />
      </linearGradient>
      <linearGradient
        id="bsg"
        x1={521.648}
        x2={10.001}
        y1={2.852}
        y2={2.852}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCFA2" />
        <stop offset={0.095} stopColor="#8C866B" />
        <stop offset={0.24} stopColor="#8C866A" />
        <stop offset={0.475} stopColor="#F5E6B6" />
        <stop offset={0.62} stopColor="#8C866B" />
        <stop offset={0.86} stopColor="#8C866B" />
        <stop offset={1} stopColor="#A59A87" />
      </linearGradient>
      <linearGradient
        id="csg"
        x1={2}
        x2={2}
        y1={5}
        y2={9}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9B8876" />
        <stop offset={1} stopColor="#AEA373" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
